import React from "react";

export function ClientNotify({ checked, onChange, email, what }) {
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm" data-testid={`notify-client-${what}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={`notify-client-${what}-checkbox`}
        className="h-4 w-4 accent-[hsl(var(--primary))]" />
      <span className="font-medium">Email client when {what}</span>
      <span className="truncate text-xs text-muted-foreground">{email ? `→ ${email}` : "(no client email on file)"}</span>
    </label>
  );
}
